import imgUserDefault from '../../../assets/img/default-user.png';
import UserRole from './UserRole';

export class CurrentUser {

    _user;
    _contractor;

    constructor(user) {
        this._user = user;
    }

    static fromUserState(user) {
        return new this(user);
    }

    static fromReduxState(state) {
        const currentUser = new this(state.auth.user);
        currentUser.setContractor(state.auth.contractor);
        return currentUser;
    }

    setContractor(contractor) {
        this._contractor = contractor;
    }

    id() {
        return this._user ? this._user.id : -1;
    }

    email() {
        return this._user.email || '';
    }

    name() {
        return this._user.name || '';
    }

    lastName() {
        return this._user.last_name || '';
    }

    completeName() {
        return `${this.name()} ${this.lastName()}`;
    }

    hasAPI() {
        return !!this._contractor && !!this._contractor.api_base_url;
    }

    hasRole() {
        return !!this._user
            && !!this._user.roles
            && !!this._user.roles[0];
    }

    role() {
        return this.hasRole()
            ? Number(this._user.roles[0].role.id)
            : -1;
    }

    roleName() {
        return this.hasRole()
            ? this._user.roles[0].role.name
            : '';
    }

    contractor() {
        return this._user.contractor;
    }

    contractorId() {
        return this._user.contractor.id;
    }

    isSuperAdmin() {
        return this.role() === UserRole.SUPERADMIN;
    }

    isAdmin() {
        return this.role() === UserRole.ADMIN;
    }

    isContractorsManager() {
        return this.role() === UserRole.CONTRACTORS_MANAGER;
    }

    isOutsourcesManager() {
        return this.role() === UserRole.OUTSOURCES_MANAGER;
    }

    isOutsourcesViewer() {
        return this.role() === UserRole.OUTSOURCES_VIEWER;
    }

    isListeriaManager() {
        return this.role() === UserRole.LISTERIA_MANAGER;
    }

    hasImage() {
        return this._user && this._user.image;
    }

    image() {
        return this.hasImage() ? this._user.image : imgUserDefault;
    }

    hasHomeScreen() {
        return this._user && this._user.home_screen;
    }

    homeScreen() {
        return this.hasHomeScreen() ? this._user.home_screen : '';
    }

    hasCompany() {
        return !!( ( this._user
            && this._user.roles
            && this._user.roles[0]
            && this._user.roles[0].company ) ||
            ( this._user && this._user.company ) );
    }

    company() {
        if ( this.hasCompany() ) {
            if ( this._user.roles[0].company ) {
                return this._user.roles[0].company;
            } else if ( this._user.company ) {
                return this._user.company;
            }
        }
        return null;
    }

    myCompanyId() {
        return this._user && this._user.my_company && this._user.my_company.id;
    }

    myCompanyName() {
        return this._user && this._user.my_company ? this._user.my_company.name : '';
    }

    isNull() {
        return !this._user;
    }

    canSeeOutsources() {
        return this.isAdmin() ||
            this.isOutsourcesManager() ||
            this.isOutsourcesViewer();
    }

    showCreateTaskWindow() {
        return this._contractor.show_create_task_window;
    }

    showListerias() {
        return this._contractor.show_listerias;
    }

    canCreateTasks() {
        return this._contractor.can_create_tasks;
    }

    enableEmailAlerts() {
        return this._contractor.enable_email_alerts;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/CurrentUser.js